String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

function generateContactBox(){
	$('table.cnpc_contact_box_manual a.phone').prepend('<span class="icon-phone"></span> ');
	$('table.cnpc_contact_box_manual a.email').prepend('<span class="icon-envelope"></span> ');
	$('table.cnpc_contact_box_manual a.external.link').prepend('<span class="icon-seach"></span> ');

	$('table.cnpc_contact_box').each(function(index){
		var contactNames = [];
		$(this).find('td').each(function() {
			contactNames.push($(this).text());
		});
		var contactBox = $('<section class="card-container"/>');
		$(this).after(contactBox);
		//contactBox.append($('<h4 class="c-card--title">Contact</h4>'));
		for(var i=0; i<contactNames.length; i++){
			var contactBoxItem = $('<div class="c-card shadow-1 mw5 relative ma3" id="'+contactNames[i].replaceAll(" ", "")+'"/>');
			contactBox.append(contactBoxItem);
			var infoDiv = $('<div class="c-card--desc pa3"/>');
			contactBoxItem.append(infoDiv);
			contactBoxItem.append($('<div class="contactDataLoadArea dn"/>'));
			infoDiv.append($('<div class="c-card--name">'+contactNames[i]+"</div>"));
			var url = "https://docs.google.com/spreadsheets/d/1NKqEuQZT2E17RvSDq7PoXQmpXuY4gGtkhMqlWYEtBCY/gviz/tq?tqx=out:html&tq=SELECT+A,+B,+C,+D,+I,+J+WHERE+A+CONTAINS+%27"+encodeURIComponent(contactNames[i])+"%27+limit+1";
			var encodedUrl = encodeURIComponent(url);
			var finalUrl = "/proxy.aspx?u="+encodedUrl+"";
			$(".card-container #"+contactNames[i].replaceAll(" ", "")+" .contactDataLoadArea").load(url, null, function(responseText, textStatus, xhr){
				if(textStatus == "error"){
					console.log('There was an error:' + responseText)
					console.log('textStatus: '+textStatus);
					console.log('xhr: '+xhr);
				}
				else{
				var data = responseText+" ";
				data = data.substring(data.indexOf("</tr>")+5, data.length);
				data = data.substring(data.indexOf("<tr"), data.indexOf("</tr>"));
				data = data.substring(data.indexOf(">")+2, data.length);
				data = data.replaceAll("</td><td>", ";").replaceAll("<td>", "").replaceAll("</td>", "");
				data = data.replaceAll("&amp;", "&");
				data = data.split(";");
				updateContactInfo(data);
				}

			});
		}
		$(this).attr("style", "display:none");
	});
}
	

function updateContactInfo(data){
	if(data[5].substring(0,1)=="✗"){
		$(".card-container #"+data[0].replaceAll(" ", "")).prepend($('<div class="c-card--header"><img class="c-card--img" src="'+data[4]+'"/></div>'));
	}else{
		$(".card-container #"+data[0].replaceAll(" ", "")).prepend($('<div class="c-card--header"><img class="c-card--img" src="/_resources/images/person-silhouette.png"/></div>'));
	}
	$(".card-container #"+data[0].replaceAll(" ", "")+" .c-card--desc").append($('<div class="c-card--job i">'+data[1]+'</div>'));
	$(".card-container #"+data[0].replaceAll(" ", "")+" .c-card--desc").append($('<div class=""><a class="c-card--phone link bg-transparent hover-bg-transparent" href="tel:'+data[2]+'"><span class="icon-phone"></span> '+data[2]+'</a></div>'));
	$(".card-container #"+data[0].replaceAll(" ", "")+" .c-card--desc").append($('<div class=""><a class="c-card--email link bg-transparent hover-bg-transparent" href="mailto:'+data[3]+'"><span class="icon-envelope"></span> '+data[3]+'</a></div>'));
}

export default {
	generateContactBox: generateContactBox
};